<div class="container-fluid hero-container">
  <div class="img-container">
  </div>
  <div class="hero-callout">
    <div class="row">
      <div class="col-12">
        <h1>
          Blog
        </h1>
      </div>
    </div>
  </div>
</div>
<div class="container second-container">
  <div class="row">
    <div class="col-12 mt-5 mb-5">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">Blog</li>
        </ol>
      </nav>
    </div>
  </div>
</div>
<div class="container third-container d-none d-lg-block pb-5">
  <div class="row">
    <div class="col-12 mb-2">
      <p *ngIf="blogCount !== 0 && blogCount <= 10">Showing 1 - {{blogCount}} of {{blogCount | number}} blogs</p>
      <p *ngIf="blogCount > 10">Showing 1 - {{take}} of {{blogCount | number}} blogs</p>
      <p *ngIf="blogCount === 0">There Are No Blogs</p>
    </div>
    <div class="col-4">
      <div *ngFor="let blog of blogs; let i = index" class="w-100">
        <div *ngIf="i < 2" class="w-100">
          <app-blog-card [blog]="blog" [limit]="300"></app-blog-card>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div *ngFor="let blog of blogs; let i = index" class="w-100">
        <div *ngIf="i === 2 || i === 3" class="w-100">
          <app-blog-card [blog]="blog" [limit]="300"></app-blog-card>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div *ngFor="let blog of blogs; let i = index" class="w-100">
        <div *ngIf="i === 4 || i === 5" class="w-100">
          <app-blog-card [blog]="blog" [limit]="300"></app-blog-card>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container third-container d-none d-md-block d-lg-none pb-5">
  <div class="row">
    <div class="col-6">
      <div *ngFor="let blog of blogs; let i = index" class="w-100">
        <div *ngIf="i < 2" class="w-100">
          <app-blog-card [blog]="blog" [limit]="300"></app-blog-card>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div *ngFor="let blog of blogs; let i = index" class="w-100">
        <div *ngIf="i === 2 || i === 3" class="w-100">
          <app-blog-card [blog]="blog" [limit]="300"></app-blog-card>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div *ngFor="let blog of blogs; let i = index" class="row">
        <div *ngIf="i === 4 || i === 5" class="col-6">
          <app-blog-card [blog]="blog" [limit]="300"></app-blog-card>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container third-container d-block d-md-none pb-5">
  <div class="row">
    <div class="col-12">
      <div *ngFor="let blog of blogs; let i = index" class="w-100">
        <div *ngIf="i < 6" class="w-100">
          <app-blog-card [blog]="blog" [limit]="300"></app-blog-card>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container pagination-container" *ngIf="blogCount !== 0">
  <div class="row">
    <div class="col-12 text-center mb-4">
      <div class="d-inline-flex" *ngIf="blogCount > 10">
        <fa-icon [icon]="['fas', 'angle-left']" size="lg" (click)="previousPage(page)">
        </fa-icon>
        <p class="flex ms-2 me-2">Page</p>
        <p class="flex page-square">{{page}}</p>
        <p class="flex ms-2 me-2">of {{blogCount / take | number:'1.0-0'}} Pages</p>
        <fa-icon [icon]="['fas', 'angle-right']" size="lg" (click)="nextPage(page)">
        </fa-icon>
      </div>
      <div class="d-inline-flex" *ngIf="blogCount < 10">
        <p class="flex ms-2 me-2">Page</p>
        <p class="flex page-square">1</p>
        <p class="flex ms-2">of 1 Page</p>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid sub-container mt-5">
  <div class="row">
    <div class="col-12">
      <app-mailing-list></app-mailing-list>
    </div>
  </div>
</div>
